/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ budget: NonNullable<unknown> }} Sub_Quotas_Over_Budget_Row_HintInputs */



/**
* | output |
* | --- |
* | "Above your organisation's total budget of {budget} — this user still stops at {budget}." |
*
* @param {Sub_Quotas_Over_Budget_Row_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_over_budget_row_hint = /** @type {((inputs: Sub_Quotas_Over_Budget_Row_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Over_Budget_Row_HintInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Über dem Gesamtbudget Ihrer Organisation von ${i?.budget} – dieser Nutzer wird weiterhin bei ${i?.budget} gestoppt.`)
	return /** @type {LocalizedString} */ (`Above your organisation's total budget of ${i?.budget} — this user still stops at ${i?.budget}.`)
});